import { EXPRESS_API } from 'configs/api/expressApi';

export type GetFolderParams = {
  folderName: string;
};

export type FolderExistsResponse = {
  folderExist: boolean;
};

export const checkFolderExist = async (
  params?: GetFolderParams
): Promise<FolderExistsResponse> => {
  return (await EXPRESS_API.get(`folders/folder-exists`, { params })).data;
};
